/**
 * @param preferenceCenter {HTMLElement}
 * @return {HTMLInputElement}
 */
module.exports = function PreferenceCenter_getPrivacyPolicyCheckbox(preferenceCenter) {
    const privacyPolicy = preferenceCenter.querySelector('[name="marketingConsent"]');
    if (privacyPolicy instanceof HTMLInputElement) {
        return privacyPolicy;
    }

    throw new Error("Cannot find privacyPolicy checkbox in PreferenceCenter!");
}